export const BREADCRUMB_LIST = [{ id: "1", title: "Resumen", active: true }]

export const TAB_GENERAL = "general"
export const TAB_PEDIDOS = "pedidos"

export const MODO_IMPORTE = "importe"
export const MODO_PIEZAS = "piezas"

// Acentos de cada tarjeta de serie temporal, tomados del diseño.
export const ACENTO_VENTAS = "#e8a33d"
export const ACENTO_COMPRAS = "#e8604c"
// La serie del año anterior siempre va en gris, en las dos tarjetas.
export const COLOR_ANTERIOR = "#c3c9d4"

// Nota mínima para pintar una barra de progreso en verde en vez de en ámbar.
export const UMBRAL_BUENO = 80
